import {CADENCE_PRICING,type BillingCadence} from "./plans";

export const SUBSCRIPTION_CADENCES: BillingCadence[]=["week","month","quarter"];
export const CADENCE_LABELS:Record<BillingCadence,string>={week:"Weekly",month:"Monthly",quarter:"Quarterly"};
export function subscriptionMoney(cents:number|null|undefined){
 return cents==null||!Number.isFinite(cents)?"Price not recorded":`$${(cents/100).toFixed(2)}`;
}
export function subscriptionOffers(){
 return SUBSCRIPTION_CADENCES.map(cadence=>({cadence,name:CADENCE_LABELS[cadence],...CADENCE_PRICING[cadence]}));
}
/** Current subscriptions use their saved Stripe interval, never the new-offer catalog. */
export function storedSubscriptionCadence(s:{billing_cadence?:string|null;interval?:string|null;interval_count?:number|null;plan_type?:string|null}){
 const count=s.interval_count??(s.interval==="month"&&s.billing_cadence==="quarter"?3:s.plan_type==="biweekly_20lb"?2:1);
 if(s.interval&&Number.isInteger(count)&&count>0){
  if(s.interval==="month"&&count===3)return "quarter";
  return count===1?s.interval:`${count} ${s.interval}s`;
 }
 return s.billing_cadence||"billing period";
}
